import { defaultHttpClient } from '../../httpClient';
import type { GoodsSellerInfoResponse } from './types';

/**
 * - 상품 판매자 정보 조회 API
 * - GET /api/v2/goods/{sno}/seller_info/
 */
export const getGoodsSellerInfo = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsSellerInfoResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/seller_info/`,
    })
    .then(result => result.data);
};
